// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('RecoveriesCustomization/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('RecoveriesCustomization/getData', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const response = await axios.get('/InvoicePreviewCustomization/GetRecoveryCustomization', { params })
    dispatch(setLoading({ getData: false }))
    return {
        params,
        data: response.data,
    }
})

export const RecoveriesCustomizationSlice = createSlice({
    name: 'RecoveriesCustomization',
    initialState: {
        data: {},
        params: {},
        loadingState: { getData: false }
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data.data
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload
            })
    }
})

export default RecoveriesCustomizationSlice.reducer
